import { InformatDefaultPage } from "../../../04templates/informat/defaultPage/InformatDefaultPage";
import { GridContainer, GridItem, GridRow } from "pu-crossproduct-components/build/components/Atoms/Grid";
import { Trans, useTranslation } from "react-i18next";
import { Body2, DisplayH1 } from "pu-crossproduct-components/build/components/Atoms/Type";
import styled from "styled-components";
import {
    Button,
    ButtonType,
    Emphasis,
    Icons,
    IconStyle
} from "pu-crossproduct-components/build/components/Molecules/Navigation/Button";
import {
    IconButton,
    IconButtonSize,
    Icons as btnIcons
} from "pu-crossproduct-components/build/components/Molecules/Navigation/IconButton";
import { Checkbox } from "pu-crossproduct-components/build/components/Molecules/Inputs/Selection";
import { useLocation } from "react-router-dom";
import { InformatExplanation } from "../InformatExplanationPage/InformatExplanation";
import { useState } from "react";
import { LogoutAction, Start2FaFlowUrl } from "../../../../routing/InformatExternalLinks/InformatExternalLinks";

const ButtonHolder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 38px;
`

const CheckboxHolder = styled.div`
  width: 100%;
  margin-top: 10px;
  line-height: 120px;
`

const BackButtonLocator = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 20px;
  
  @media (min-width: 768px) {
    justify-content: flex-end;
    padding-top: 40px;
    padding-right: 20px;
  }
`

export const InformatUsernamelogin2FactorMessage: React.FC = props => {
    const { t } = useTranslation();
    const [OpenExplantionPage, SetOpenExplantionPage] = useState<boolean>(false);
    const location = useLocation();
    const returnUrlParsed = (new URLSearchParams(location.search)).get("returnUrl");
    const returnUrl = returnUrlParsed ? returnUrlParsed : "";
    const rememberDays = 14;

    return <InformatDefaultPage>

        <GridContainer>
            <GridRow>
                <GridItem col={0} tablet={1} laptopL={3} />
                <GridItem col={12} tablet={1}>
                    <BackButtonLocator>
                        <Button onClick={LogoutAction} icon={btnIcons.chevronLeft} emphasis={Emphasis.medium} iconStyle={IconStyle.iconOnly} />
                    </BackButtonLocator>
                </GridItem>
                <GridItem col={12} tablet={8} laptopL={4}>
                    <form action={Start2FaFlowUrl} method={"POST"} >
                        <input type={"hidden"} name="returnUrl" value={returnUrl} />
                        <DisplayH1>
                            <Trans t={t}>twoFactorInformatIntroPageRedirectTitle</Trans>
                        </DisplayH1>
                        <Body2>
                            <Trans t={t}>twoFactorInformatIntroPageRedirectShortDescription</Trans>
                        </Body2>
                        <ButtonHolder>
                            <Button type={ButtonType.submit}>
                                <Trans t={t}>twoFactorInformatIntroPageRedirectButton</Trans>
                            </Button>
                            <IconButton icon={Icons.infoCircle} size={IconButtonSize.small} onclick={(e) => {
                                e.preventDefault();
                                SetOpenExplantionPage(true);
                            }} />
                        </ButtonHolder>
                        <CheckboxHolder>
                            <Checkbox name="rememberMe" value="true">
                                <Trans t={t}
                                    values={{ rememberDays: rememberDays }}>twoFactorInformatIntroPageRedirectRemember</Trans>
                            </Checkbox>
                        </CheckboxHolder>
                    </form>
                </GridItem>
                <GridItem col={0} tablet={2} laptopL={4} />
            </GridRow>
        </GridContainer>
        <InformatExplanation open={OpenExplantionPage} onClose={() => SetOpenExplantionPage(false)} />
    </InformatDefaultPage>
}
